import { FEATURE_MNG } from '@/api/apiModules'

export default {
  viewType: 'table',
  module: FEATURE_MNG + '/relateTestCase',
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  params: {},
  extraParams: {},
  // relationSearch: true,
  allowStatus: {
    TestCaseSharedEdit: { owner: [true] },
    TestCaseSharedDelete: { owner: [true] },
    TestCaseSharedCopy: { relevant: ['SPEC'] }
  },
  toolbar: {
    searchWidth: 360,
    searchPlaceholder: '创建人/用例名称',
    searchFieldNameArr: ['testCaseName', 'realName'],
    items: []
  },

  view: {
    columns: [
      {
        props: {
          label: '用例编码',
          prop: 'testCaseCode',
          width: 135,
          sortField: 'testCaseCode'
        },
        dataType: 'custom',
        custom: function(row, h, value, e) {
          return (
            <div
              class="sk-link--normal"
              on-click={$event => {
                this.$store.dispatch('TestCaseSharedDrawerDetail', row)
              }}
            >
              {value}
            </div>
          )
        }
      },
      {
        props: {
          label: '用例名称',
          prop: 'testCaseName'
        }
      },
      {
        props: {
          label: '用例步骤',
          prop: 'testCaseStep'
        }
      },
      {
        props: {
          label: '用例来源',
          prop: 'testCaseCategory',
          sortField: 'testCaseCategory',
          width: 110
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'testCaseCategory'
      },
      {
        props: {
          label: 'testcaseMng.testCaseType',
          prop: 'testCaseType',
          sortField: 'testCaseType',
          width: 110
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'testCaseType'
      },
      {
        props: {
          label: '创建人',
          prop: 'realName',
          width: 100
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 160
        },
        dataType: 'date'
      }
    ],
    menus: []
  }
}
